import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe54e2ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "lg:flex lg:flex-row lg:justify-center lg:flex-wrap mt-x1" }


import useSearch from '@/shared/search/useSearch';
import navigationStore from '@/shared/navigation/navigation.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultItems',
  props: {
    title: null,
    items: null
  },
  setup(__props: any) {



const { searchPageLink } = useSearch();


return (_ctx: any,_cache: any) => {
  const _component_RouterLinkConditional = _resolveComponent("RouterLinkConditional")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createVNode(_component_RouterLinkConditional, {
      to: _unref(searchPageLink),
      title: __props.title,
      "spa-enabled": false,
      onKeydownPassive: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_unref(navigationStore).toggleActiveMainNavigationItem(null)), ["enter"])),
      onClickPassive: _cache[1] || (_cache[1] = ($event: any) => (_unref(navigationStore).toggleActiveMainNavigationItem(null)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("h2", {
          class: _normalizeClass({ 'c-magic-line': _unref(searchPageLink) })
        }, _toDisplayString(__props.title), 3)
      ]),
      _: 1
    }, 8, ["to", "title"]),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, idx) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.link+idx,
          class: "content-item"
        }, [
          _createVNode(_component_RouterLinkConditional, {
            to: item.link,
            class: "c-magic-line",
            "spa-enabled": false,
            onKeydownPassive: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_unref(navigationStore).toggleActiveMainNavigationItem(null)), ["enter"])),
            onClickPassive: _cache[3] || (_cache[3] = ($event: any) => (_unref(navigationStore).toggleActiveMainNavigationItem(null)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ])
  ]))
}
}

})